import React from 'react';
import { Box, Typography } from '@mui/material';

export interface ChatHeaderProps {
  title: string;
  /** What the chat answers from, e.g. "Answers from this board". */
  subtitle?: string;
  /** Buttons on the right: open full size, close, new chat. */
  actions?: React.ReactNode;
}

/** The strip across the top of a chat: its title and a few actions. */
export function ChatHeader({ title, subtitle, actions }: ChatHeaderProps) {
  return (
    <Box
      sx={(t) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1,
        minHeight: t.ds.sizes.control.lg + 12,
        borderBottom: `1px solid ${t.tokens.border.subtle}`,
        flexShrink: 0,
      })}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="subtitle2" noWrap component="h2" sx={{ m: 0 }}>{title}</Typography>
        {subtitle && (
          <Typography variant="caption" noWrap component="div" sx={(t) => ({ color: t.tokens.text.tertiary })}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>{actions}</Box>}
    </Box>
  );
}
